import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentJourneyPreparation(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentJourneyPreparation.url, { id: enrollmentId })
    )
    .get<{ content: string }>()
}

export function getEnrollmentCanAccessJourneyPreparation(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentCanAccessJourneyPreparation.url, {
        id: enrollmentId
      })
    )
    .get<boolean>()
}
